var enLang = {
	"Thanh toán trực tuyến": "Online payment",
	"Thanh toán Online qua cổng VNPAY": "Online payment via VNPAY",
	"Thanh toán khi nhận hàng": "Cash on delivery (COD)",
	"Tiêu điểm thành viên": "Point redemtion",
	"Tiền mặt": "Cash",
	"Thanh toán trả góp": "Installment"
};

export { enLang as default };
